// extracted by mini-css-extract-plugin
module.exports = {"navbar-brand-box":"Header_navbar-brand-box__1SqH2","logo-img-lg":"Header_logo-img-lg__2suj8","logo-img-sm":"Header_logo-img-sm__FQ7Ge","logo-sm":"Header_logo-sm__3qk1v"};